var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGpsFixed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "gps_fixed",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_46188",
    "data-name": "Path 46188",
    d: "M0,0H24V24H0Z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_46189",
    "data-name": "Path 46189",
    d: "M12,8a4,4,0,1,0,4,4A4,4,0,0,0,12,8Zm8.94,3A8.994,8.994,0,0,0,13,3.06V2a1,1,0,0,0-2,0V3.06A8.994,8.994,0,0,0,3.06,11H2a1,1,0,0,0,0,2H3.06A8.994,8.994,0,0,0,11,20.94V22a1,1,0,0,0,2,0V20.94A8.994,8.994,0,0,0,20.94,13H22a1,1,0,0,0,0-2H20.94ZM12,19a7,7,0,1,1,7-7A6.995,6.995,0,0,1,12,19Z",
    fill: "#0078d7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGpsFixed);
export default __webpack_public_path__ + "static/media/gps_fixed.47cfc2c5d4cec9bf60b2456851135c9c.svg";
export { ForwardRef as ReactComponent };